interface PullQuoteProps {
  text: string
  author: string
}

export function PullQuote({ text, author }: PullQuoteProps) {
  return (
    <section aria-label="On language" className="relative z-10 py-16 sm:py-28">
      <div className="max-w-3xl mx-auto px-4 sm:px-8 text-center">
        <span
          aria-hidden="true"
          className="block font-serif text-[64px] leading-none text-accent opacity-50"
          style={{ height: '30px' }}
        >
          "
        </span>
        <blockquote>
          <p className="font-serif italic text-2xl sm:text-[32px] leading-[1.34] tracking-[-0.012em] text-heading">
            <q className="[quotes:none]">{text}</q>
          </p>
          <cite className="mt-7 block font-mono text-xs uppercase tracking-widest text-muted not-italic">
            {author}
          </cite>
        </blockquote>
      </div>
    </section>
  )
}
